<template>
	<div class="container-wrap">
		<div class="container">
			<div v-html="content"></div>
		</div>
	</div>
</template>
<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Home',
		components: {
			
		},
		data() {
			return {
				id: '',
				content: ''
			}
		},
		created(){
			let id = this.$route.params.id
			this.id = id
			this.getDataPage()
		},
		methods: {
			//获取单页内容
			async getDataPage(){
				let param = {
					linkId: this.id
				}
				ajaxParam(param)
				const res = await post('v1/singlePage/data', qs.stringify(param))
				if(res.data.code==200){
					this.content = res.data.entity.content
					document.title = res.data.entity.pageName
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>
<style scoped lang="less">
	@import '../product.less';
	.list-wrap{
		margin-bottom: 15px;
		h1{
			font-weight: 400;
			font-size: 18px;
			letter-spacing: 1.29px;
			line-height: 50px;
		}
		.list{
			padding: 14px 23px;
			border: 1px solid #dadada;
			height: auto;
			-webkit-transition: all .3s;
			transition: all .3s;
			display: flex;
			flex-wrap: wrap;
			li{
				flex: 33%;
				max-width: 31%;
				padding: 0 1%;
				line-height: 32px;
			}
		}
	}
</style>
